import { Box, Grid, Skeleton, Typography, useMediaQuery } from '@mui/material';
import LineupVariantSelector from '../shared/lineup/LineupVariantSelector';
import { ClockIcon } from '@mui/x-date-pickers';
import { getTimeAgo } from '@/helpers/datetime-helper';
import PartidoInfoNavigation from '../shared/complementos/PartidoInfoNavigation';
import LineupHorizontal from '../shared/lineup/LineupHorizontal';
import InformaciónRelacionada from '../shared/complementos/InformaciónRelacionada';
import VoteFixtureComponent from '../shared/complementos/VoteFixtureComponent';
import ComparacionEquipos from '../shared/complementos/ComparacionEquipos';
import DificultadDePartido from '../shared/complementos/DificultadDePartido';
import LastFixtureBanner from '../shared/complementos/LastFixtureBanner';
import LineupVertical from '../shared/lineup/LineupVertical';
import LineupSplit from '../shared/lineup/LineupSplit';
import { useEffect, useState } from 'react';
import TitularesYSuplentes from '../shared/Jugadores/TitularesYSuplentes';
import DonquiCardEquipo from '../shared/complementos/DonquiCardEquipo';
import UltimosPartidosEquipo from '../shared/complementos/UltimosPartidosEquipo';
import ProximosPartidosEquipo from '../shared/complementos/ProximosPartidosEquipo';
import PartidoEventos from '../shared/complementos/PartidoEventos';
import JugadoresStatusCards from '../shared/Jugadores/JugadoresStatusCards';
import CollapsableWrapper from '@/DesignSystem/wrappers/CollapsableWrapper';
import Placement1Component from '@/components/ads-components/placements/placement1';
import Placement6Component from '@/components/ads-components/placements/placement6';
import Placement15Component from '@/components/ads-components/placements/placement15';
import Placement12Component from '@/components/ads-components/placements/placement12';
import Placement100Component from '@/components/ads-components/placements/placement100';
import Placement200Component from '@/components/ads-components/placements/placement200';
import LideresFantasyPlayers from '../shared/complementos/LideresFantasyPlayers';
import LineupSummary from '../shared/complementos/LineupSummary';
import { usePartidoAlineaciones } from './PartidoAlineacionesContext';

const LineupVariantSelectorWithTime = ({ mb, isMobile }) => {
    const { variant, setVariant, data } = usePartidoAlineaciones();

    return (
        <Box display="flex" justifyContent="space-between" flexDirection={'column'} width={'100%'} mb={mb}>
            <Typography fontSize={15} component={'h2'} mb={0.5}>
                Modo de visualización
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <LineupVariantSelector
                    variant={variant}
                    setVariant={setVariant}
                    tipo={'partido'}
                    isMobile={isMobile}
                />
                {data?.lastTimeUpdated && (
                    <Box display="flex" alignItems="center" gap={0.2}>
                        <ClockIcon sx={{ color: 'text.primary', fontSize: 12 }} />
                        <Typography fontSize={10} color="text.primary">
                            {getTimeAgo(data.lastTimeUpdated)}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

const PartidoAlineacionesProbablesHorizontal = ({ isMobile }) => {
    const {
        data,
        prediccionTiempo,
        events,
        estadisticasPartido,
        stats,
        handleOpenJugador,
        fantasyEnabled,
        mode,
        home,
        away,
    } = usePartidoAlineaciones();
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 9 }}>
                <PartidoInfoNavigation home={home} away={away} fixture={data?.fixture} mode={mode} />
                <LineupVariantSelectorWithTime mb={1} isMobile={isMobile} />
                <Box display={{ xs: 'none', md: 'flex' }} gap={1} justifyContent={'space-between'}>
                    <Box width={{ xs: '0', md: '50.5%' }}>
                        <LastFixtureBanner data={home?.lastFixture} />
                        <DonquiCardEquipo equipo={home} mode={mode} />
                    </Box>
                    <Box width={{ xs: '0', md: '49.5%' }}>
                        <LastFixtureBanner data={away?.lastFixture} />

                        <DonquiCardEquipo equipo={away} mode={mode} flexDirection="row-reverse" />
                    </Box>
                </Box>

                <Box display={{ xs: 'flex', md: 'none' }} width={'100%'}>
                    <LastFixtureBanner data={home?.lastFixture} />
                    <DonquiCardEquipo equipo={home} mode={mode} />
                </Box>
                <LineupHorizontal
                    mode={mode}
                    home={home?.lineup}
                    away={away?.lineup}
                    prediccionTiempo={prediccionTiempo}
                    estadisticasPartido={estadisticasPartido}
                    events={events}
                    tipo={'partido'}
                    homeFormation={home?.formation}
                    awayFormation={away?.formation}
                    handleOpenJugador={handleOpenJugador}
                    isMobile={isMobile}
                    homeId={home?.id}
                    awayId={away?.id}
                    fantasyEnabled={fantasyEnabled}
                />

                {isMobile && <Placement6Component />}

                <Box display={{ xs: 'flex', md: 'none' }} width={'100%'}>
                    <LastFixtureBanner data={away?.lastFixture} />
                    <DonquiCardEquipo equipo={away} mode={mode} />
                </Box>
                <Grid container spacing={1} sx={{ mt: 1 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {mode === 'predict' && <LineupSummary players={home?.lineup} />}
                        <TitularesYSuplentes
                            lineup={home?.lineup}
                            mode={mode}
                            events={events}
                            estadisticasPartido={estadisticasPartido}
                            equipo={home?.name}
                            handleOpenJugador={handleOpenJugador}
                            teamId={home?.id}
                        />
                        {mode === 'predict' && (
                            <>
                                <JugadoresStatusCards jugadores={home?.lineup} />
                                <LideresFantasyPlayers players={home?.lineup} />
                            </>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {mode === 'predict' && <LineupSummary players={away?.lineup} />}
                        <TitularesYSuplentes
                            lineup={away?.lineup}
                            mode={mode}
                            events={events}
                            estadisticasPartido={estadisticasPartido}
                            equipo={away?.name}
                            handleOpenJugador={handleOpenJugador}
                            teamId={away?.id}
                        />
                        {mode === 'predict' && (
                            <>
                                <JugadoresStatusCards jugadores={away?.lineup} />
                                <LideresFantasyPlayers players={away?.lineup} />
                            </>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            {isMobile && <Placement100Component />}
            <Grid size={{ xs: 12, lg: 3 }}>
                <InformaciónRelacionada />
                <VoteFixtureComponent data={data} />
                <ComparacionEquipos home={home} away={away} stats={stats} />
                {isMobile ? <Placement1Component /> : <Placement15Component />}
                {mode === 'predict' && <DificultadDePartido home={home} away={away} />}
                <ProximosPartidosEquipo equipo={home} />
                <UltimosPartidosEquipo equipo={home} />
                <Placement200Component />
                <ProximosPartidosEquipo equipo={away} />
                <UltimosPartidosEquipo equipo={away} />
                {mode === 'last' && (
                    <>
                        <PartidoEventos events={events} fixture={data?.home?.lastFixture} />
                        <PartidoEventos events={events} fixture={data?.away?.lastFixture} />
                    </>
                )}
                {mode === 'confirmed' && (
                    <>
                        <PartidoEventos events={events} fixture={data?.fixture} />
                    </>
                )}
            </Grid>
        </Grid>
    );
};

const PartidoAlineacionesProbablesVertical = ({ isUnderDesktop, isMobile }) => {
    const {
        data,
        prediccionTiempo,
        events,
        estadisticasPartido,
        stats,
        handleOpenJugador,
        fantasyEnabled,
        mode,
        home,
        away,
    } = usePartidoAlineaciones();

    if (isUnderDesktop) {
        return (
            <>
                <PartidoInfoNavigation home={home} away={away} fixture={data?.fixture} mode={mode} />
                <LineupVariantSelectorWithTime mb={1} isMobile={isMobile} />
                <LastFixtureBanner data={home?.lastFixture} />
                <DonquiCardEquipo equipo={home} mode={mode} />
                {mode === 'predict' && <LineupSummary players={home?.lineup} />}
                <Placement1Component />
                <LineupVertical
                    lineup={home?.lineup}
                    mb={1}
                    prediccionTiempo={prediccionTiempo}
                    mode={mode}
                    estadisticasPartido={estadisticasPartido}
                    events={events}
                    formation={home?.formation}
                    handleOpenJugador={handleOpenJugador}
                    isUnderDesktop={isUnderDesktop}
                    teamId={home?.id}
                    fantasyEnabled={fantasyEnabled}
                    weatherIconPosition="right"
                />
                <Placement6Component />
                <TitularesYSuplentes
                    lineup={home?.lineup}
                    mode={mode}
                    events={events}
                    estadisticasPartido={estadisticasPartido}
                    equipo={home?.name}
                    defaultOpen={false}
                    mb={1}
                    handleOpenJugador={handleOpenJugador}
                />
                {mode === 'predict' && (
                    <>
                        <CollapsableWrapper
                            title={`${home?.name}: Lesionados, sancionados y dudas`}
                            defaultOpen={false}
                            mb={1}
                            fontSizeTitle={14}
                        >
                            <JugadoresStatusCards jugadores={home?.lineup} />
                        </CollapsableWrapper>
                        <CollapsableWrapper
                            title={`${home?.name}: Lideres Fantasy`}
                            defaultOpen={false}
                            mb={1}
                            fontSizeTitle={14}
                        >
                            <LideresFantasyPlayers players={home?.lineup} />
                        </CollapsableWrapper>

                        <Placement6Component />
                        <CollapsableWrapper
                            title={`${away?.name}: Lideres Fantasy`}
                            defaultOpen={false}
                            mb={1}
                            fontSizeTitle={14}
                        >
                            <LideresFantasyPlayers players={away?.lineup} />
                        </CollapsableWrapper>
                        <CollapsableWrapper
                            title={`${away?.name}: Lesionados, sancionados y dudas`}
                            defaultOpen={false}
                            mb={1}
                            fontSizeTitle={14}
                        >
                            <JugadoresStatusCards jugadores={away?.lineup} />
                        </CollapsableWrapper>
                    </>
                )}

                <TitularesYSuplentes
                    lineup={away?.lineup}
                    mode={mode}
                    events={events}
                    estadisticasPartido={estadisticasPartido}
                    equipo={away?.name}
                    defaultOpen={false}
                    mb={1}
                    handleOpenJugador={handleOpenJugador}
                />

                <LastFixtureBanner data={away?.lastFixture} />
                <LineupVertical
                    lineup={away?.lineup}
                    mb={1}
                    prediccionTiempo={prediccionTiempo}
                    mode={mode}
                    estadisticasPartido={estadisticasPartido}
                    events={events}
                    formation={away?.formation}
                    handleOpenJugador={handleOpenJugador}
                    isUnderDesktop={isUnderDesktop}
                    teamId={away?.id}
                    fantasyEnabled={fantasyEnabled}
                    weatherIconPosition="right"
                />
                {mode === 'predict' && <LineupSummary players={away?.lineup} />}
                <DonquiCardEquipo equipo={away} mode={mode} />
                <InformaciónRelacionada />
                <VoteFixtureComponent data={data} />
                <Placement100Component />
                <ComparacionEquipos home={home} away={away} stats={stats} />
                {mode === 'confirmed' && (
                    <>
                        <PartidoEventos events={events} fixture={data?.fixture} />
                    </>
                )}
                <ProximosPartidosEquipo equipo={home} />
                <UltimosPartidosEquipo equipo={home} />

                {mode === 'predict' && <DificultadDePartido home={home} away={away} />}
                <ProximosPartidosEquipo equipo={away} />
                <UltimosPartidosEquipo equipo={away} />
                {mode === 'last' && (
                    <>
                        <PartidoEventos events={events} fixture={home?.lastFixture} />
                        <PartidoEventos events={events} fixture={away?.lastFixture} />
                    </>
                )}
            </>
        );
    }

    return (
        <Grid container spacing={1}>
            <Grid size={{ xs: 12, lg: 9.2 }}>
                <Grid container spacing={1}>
                    <PartidoInfoNavigation home={home} away={away} fixture={data?.fixture} mode={mode} />
                    <LineupVariantSelectorWithTime isMobile={isMobile} />
                    <Grid size={{ xs: 12, md: 6 }}>
                        <LastFixtureBanner data={home?.lastFixture} />
                        <DonquiCardEquipo equipo={home} mode={mode} />
                        {mode === 'predict' && <LineupSummary players={home?.lineup} />}
                        <LineupVertical
                            lineup={home?.lineup}
                            mb={1}
                            prediccionTiempo={prediccionTiempo}
                            mode={mode}
                            estadisticasPartido={estadisticasPartido}
                            events={events}
                            formation={home?.formation}
                            handleOpenJugador={handleOpenJugador}
                            isUnderDesktop={isUnderDesktop}
                            teamId={home?.id}
                            fantasyEnabled={fantasyEnabled}
                            weatherIconPosition="right"
                        />
                        <TitularesYSuplentes
                            lineup={home?.lineup}
                            mode={mode}
                            events={events}
                            estadisticasPartido={estadisticasPartido}
                            equipo={home?.name}
                            mb={1}
                            handleOpenJugador={handleOpenJugador}
                        />
                        {mode === 'predict' && (
                            <>
                                <JugadoresStatusCards jugadores={home?.lineup} />
                                <LideresFantasyPlayers players={home?.lineup} />
                            </>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <LastFixtureBanner data={away?.lastFixture} />
                        <DonquiCardEquipo equipo={away} mode={mode} flexDirection="row-reverse" />
                        {mode === 'predict' && <LineupSummary players={away?.lineup} />}
                        <LineupVertical
                            lineup={away?.lineup}
                            mb={1}
                            prediccionTiempo={prediccionTiempo}
                            mode={mode}
                            estadisticasPartido={estadisticasPartido}
                            events={events}
                            formation={away?.formation}
                            handleOpenJugador={handleOpenJugador}
                            isUnderDesktop={isUnderDesktop}
                            teamId={away?.id}
                            fantasyEnabled={fantasyEnabled}
                            weatherIconPosition="right"
                        />
                        <TitularesYSuplentes
                            lineup={away?.lineup}
                            mode={mode}
                            events={events}
                            estadisticasPartido={estadisticasPartido}
                            equipo={away?.name}
                            mb={1}
                            handleOpenJugador={handleOpenJugador}
                        />
                        {mode === 'predict' && (
                            <>
                                <JugadoresStatusCards jugadores={away?.lineup} />
                                <LideresFantasyPlayers players={away?.lineup} />
                            </>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={{ xs: 12, lg: 2.8 }}>
                <VoteFixtureComponent data={data} />
                <ComparacionEquipos home={home} away={away} stats={stats} />

                <Placement15Component />
                {mode === 'predict' && (
                    <>
                        <DificultadDePartido home={home} away={away} />
                    </>
                )}
                {mode === 'last' && (
                    <>
                        <PartidoEventos events={events} fixture={home?.lastFixture} />
                        <PartidoEventos events={events} fixture={away?.lastFixture} />
                    </>
                )}
                {mode === 'confirmed' && (
                    <>
                        <PartidoEventos events={events} fixture={data?.fixture} />
                    </>
                )}
                <Placement1Component />
                <ProximosPartidosEquipo equipo={home} />
                <ProximosPartidosEquipo equipo={away} />
                <UltimosPartidosEquipo equipo={home} />
                <UltimosPartidosEquipo equipo={away} />
            </Grid>
        </Grid>
    );
};

const PartidoAlineacionesProbablesSplit = ({ isMobile }) => {
    const {
        data,
        events,
        estadisticasPartido,
        stats,
        handleOpenJugador,
        fantasyEnabled,
        mode,
        home,
        away,
        prediccionTiempo,
    } = usePartidoAlineaciones();
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <PartidoInfoNavigation home={home} away={away} fixture={data?.fixture} mode={mode} />
                <LineupVariantSelectorWithTime isMobile={isMobile} />
            </Grid>
            <Grid size={{ xs: 12, lg: 5, md: 6 }}>
                <LastFixtureBanner data={home?.lastFixture} />
                <DonquiCardEquipo equipo={home} mode={mode} />
                {mode === 'predict' && <LineupSummary players={home?.lineup} />}
                <LineupSplit
                    mode={mode}
                    home={home?.lineup}
                    away={away?.lineup}
                    prediccionTiempo={prediccionTiempo}
                    weatherIconPosition="left"
                    estadisticasPartido={estadisticasPartido}
                    events={events}
                    homeFormation={home?.formation}
                    awayFormation={away?.formation}
                    handleOpenJugador={handleOpenJugador}
                    isMobile={isMobile}
                    fantasyEnabled={fantasyEnabled}
                    homeId={home?.id}
                    awayId={away?.id}
                />
                <LastFixtureBanner data={away?.lastFixture} />
                {mode === 'predict' && <LineupSummary players={away?.lineup} />}
                <DonquiCardEquipo equipo={away} mode={mode} />
                {isMobile ? <Placement1Component /> : <Placement15Component />}
            </Grid>
            <Grid size={{ xs: 12, lg: 4, md: 6 }}>
                <TitularesYSuplentes
                    lineup={home?.lineup}
                    mode={mode}
                    events={events}
                    estadisticasPartido={estadisticasPartido}
                    equipo={home?.name}
                    handleOpenJugador={handleOpenJugador}
                    teamId={home?.id}
                />
                {!isMobile && <Placement1Component />}
                <TitularesYSuplentes
                    lineup={away?.lineup}
                    mode={mode}
                    events={events}
                    estadisticasPartido={estadisticasPartido}
                    equipo={away?.name}
                    handleOpenJugador={handleOpenJugador}
                    teamId={away?.id}
                />
                {isMobile && <Placement6Component />}
                <ProximosPartidosEquipo equipo={home} />
                <UltimosPartidosEquipo equipo={home} />
                <ProximosPartidosEquipo equipo={away} />
                <UltimosPartidosEquipo equipo={away} />
                {isMobile && <Placement15Component />}
            </Grid>
            <Grid size={{ xs: 12, lg: 3, md: 12 }}>
                <VoteFixtureComponent data={data} />
                <ComparacionEquipos home={home} away={away} stats={stats} />
                {mode === 'predict' && <DificultadDePartido home={home} away={away} />}
                {isMobile && <Placement12Component />}
                {mode === 'last' && (
                    <>
                        <PartidoEventos events={events} fixture={data?.home?.lastFixture} />
                        <PartidoEventos events={events} fixture={data?.away?.lastFixture} />
                    </>
                )}
                {mode === 'confirmed' && (
                    <>
                        <PartidoEventos events={events} fixture={data?.fixture} />
                    </>
                )}
            </Grid>
        </Grid>
    );
};

const PartidoAlineacionesProbablesMain = () => {
    const [isClient, setIsClient] = useState(false);
    const { variant } = usePartidoAlineaciones();
    const isMobile = useMediaQuery('(max-width: 576px)');
    const isUnderDesktop = useMediaQuery('(max-width: 1200px)');

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return (
            <Box className="container">
                <Typography variant="h1" mb={1}>
                    Alineaciones probables
                </Typography>
                <Skeleton variant="rectangular" height={30} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" height={700} sx={{ mb: 1 }} />
            </Box>
        );
    }

    if (variant === 'horizontal') {
        return <PartidoAlineacionesProbablesHorizontal isMobile={isMobile} />;
    } else if (variant === 'split') {
        return <PartidoAlineacionesProbablesSplit isMobile={isMobile} />;
    } else if (variant === 'vertical') {
        return <PartidoAlineacionesProbablesVertical isUnderDesktop={isUnderDesktop} isMobile={isMobile} />;
    }
};

export default PartidoAlineacionesProbablesMain;
